import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/master/semesters/semesterListContainer';
import { actions } from '../../../redux/master/semesters';

export default function () {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getInitData({}));
  }, []);
  return (
    <Container />
  );
}
